import useMinWidth from '@/hooks/useMinWidth'

export function useIsMinWidthSm() {
  return useMinWidth('sm')
}
